import { createRuntime, loginRequestB2B, loginRequestB2C, msalInstance } from '../shared/utils';
import { ApplicationInsightsLogger, getAppInsights, initializeApplicationInsights } from '../shell';
import { Shell } from '../shared/types';
import { init, loadRemote } from '@module-federation/enhanced/runtime';
import { packageJsonDependencies } from '../config';
import { remoteStore } from './registerStore';
import { BrowserUtils } from '@azure/msal-browser';
async function initializeNew(shell, remotes, loggers, useAuthorizationOrganizationFakes) {
    const runtime = createRuntime({ shell, loggers });
    runtime.setAllRemotes(remotes);
    runtime.setFakes(useAuthorizationOrganizationFakes);
    initializeApplicationInsights(shell, remotes);
    runtime.logger.addLogger(new ApplicationInsightsLogger());
    if (BrowserUtils.isInIframe())
        return runtime;
    // handle auth redired/do all initial setup for msal
    await msalInstance
        .handleRedirectPromise()
        .then(async (_) => {
        // Check if user signed in
        const account = msalInstance.getActiveAccount();
        if (!account) {
            shell === Shell.Business
                ? msalInstance.loginRedirect({
                    ...loginRequestB2B(),
                })
                : msalInstance.loginRedirect({
                    ...loginRequestB2C,
                });
        }
        else {
            const account = msalInstance.getActiveAccount();
            if (account) {
                getAppInsights().getValue().setAuthenticatedUserContext(account.username, account.localAccountId, true);
            }
        }
    })
        .catch(err => {
        // TODO: Handle errors
        console.log(err);
    });
    return runtime;
}
const fallbackPlugin = function () {
    return {
        name: 'fallback-plugin',
        errorLoadRemote(args) {
            const fallback = 'fallback';
            if (process.env.NODE_ENV === 'development') {
                console.warn('Failed to initialize remote:', args.id);
            }
            return fallback;
        },
    };
};
export async function initializeRuntime({ remotes = [], shell = Shell.Business, loggers = null, name, register, registerNav, useAuthorizationOrganizationFakes = false, }) {
    const runtime = await initializeNew(shell, remotes, loggers, useAuthorizationOrganizationFakes);
    const shared = [
        'react',
        'react-dom',
        'react-router-dom',
        '@sgi/af-shell-shared',
        '@emotion/react',
        '@azure/msal-browser',
    ].reduce((acc, packageName) => {
        acc[packageName] = {
            version: packageJsonDependencies[packageName],
            scope: 'default',
            lib: () => packageName,
            shareConfig: {
                singleton: true,
                requiredVersion: packageJsonDependencies[packageName],
            },
        };
        return acc;
    }, {});
    init({
        name,
        remotes: remotes.map(r => ({
            name: r.name,
            entry: `${r.url}/${r.entry ?? 'remoteEntry.js'}?v=${new Date().getTime()}`,
            shared,
        })),
        plugins: [fallbackPlugin()],
    });
    void loadPromises(remotes, runtime);
    // if we're just running the remote
    if (register) {
        await register(runtime);
        remoteStore.setRemoteReady(name, 'register');
    }
    if (registerNav) {
        await registerNav(runtime);
        remoteStore.setRemoteReady(name, 'registerNav');
    }
    return runtime;
}
export const loadPromises = async (remotes, runtime) => {
    let promises = [];
    remotes.forEach((remote) => {
        remote.modules.forEach(m => {
            if (m === 'register') {
                remoteStore.setRemoteInitializing(remote.name, m);
            }
            promises.push(loadRemote(`${remote.name}/${m}`).then((result) => {
                return { remote, result };
            }));
        });
    });
    try {
        const results = await Promise.all(promises);
        results.map(async ({ remote, result }) => {
            if (typeof result === 'object' && result.register) {
                await result.register(runtime);
                remoteStore.setRemoteReady(remote.name, 'register');
            }
            else if (typeof result === 'object' && result.registerNav) {
                await result.registerNav(runtime);
            }
            else {
                remoteStore.setRemoteError(remote.name, 'register');
            }
        });
    }
    catch (error) {
        console.error(error);
    }
};
